exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\n[data-component='last-transaction'] {\n  position: relative;\n  margin-top: 20px;\n}\n[data-component='last-transaction'] .box {\n  padding: 10px 20px;\n  cursor: pointer;\n}\n[data-component='last-transaction'] .btn-arrow {\n  background: transparent;\n  border: 0;\n  color: #ff720a;\n  color: var(--secondary);\n  position: absolute;\n  right: 0;\n  top: 9px;\n}\n[data-component='last-transaction'] .btn-arrow i {\n  font-size: 40px;\n}\n[data-component='last-transaction'] h3,\n[data-component='last-transaction'] h5 {\n  margin: 0;\n  font-family: 'MuseoSans';\n  font-weight: 500;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/dashboard/last-transactions/last-transactions.component.styl
// module id = ../../../../../src/app/master/dashboard/last-transactions/last-transactions.component.styl
// module chunks = main